require './application'
# require 'jquery.ripples'

$(document).ready ->
  # $('.overlay-layer ').ripples
  #   interactive: false
  #   resolution: 2000
  #   perturbance: 0.04

  # x = $('.overlay-layer ').innerWidth()*0.95 / 2
  # y = $('.overlay-layer ').innerHeight() / 2

  # setTimeout (->
  #   $('.overlay-layer ').ripples('drop', x, y, 40, 5)
  # ), 500

  # # setTimeout (->
  # #   $('.overlay-layer .images').ripples('drop', x, y, 10, 5)
  # # ), 1000


  # setTimeout (->
  #   $('.overlay-layer ').ripples('destroy');
  # ), 7000

  # $('.overlay-layer img').waterripple()

  # setTimeout (->
  #   i = 1
  #   while i <= 4
  #     if i == curpage
  #       a = document.getElementById(pagePrefix + i)
  #       a.className += ' up1'
  #     else
  #       b = document.getElementById(pagePrefix + i)
  #       b.classList.remove 'up1'
  #     i++
  #   sliding = true
  #   return
  # ), 600


  # setTimeout (->
  #   for j in [10..18]
  #     c = document.getElementById("circle-#{j}")
  #     c.classList.remove 'streak'
  #     c.setAttribute 'class', "circle-#{j} steap"
  #     j++
  #   sliding = true
  #   return
  # ), 850

  # return


  # move = ->
  #   for j in [1..9]
  #     c = document.getElementById("circle-#{j}")
  #     c.classList.remove 'steap'
  #     c.setAttribute 'class', "circle-#{j} streak"

  # setTimeout (->
  #   move()
  # ), 3200


  setTimeout (->
    for elem in $('.dwellfence')
      circleAnimate $(elem).find('.dwellfence-container'), Math.floor(Math.random() * (90 - 10)) + 10
  ), 3000

  # setTimeout (->
  #   $('.overlay-layer').hide()
  # ), 6000

  circleAnimate = ($el, end, i) ->
    if end < 0
      end = 0
    else if end > 100
      end = 100
    if typeof i == 'undefined'
      i = 0
    curr = 100 * i / 360

    if i <= 180
      $el.css 'background-image', 'linear-gradient(' + 90 + i + 'deg, transparent 50%, rgb(32, 72, 30)  50%),linear-gradient(90deg, rgb(32, 72, 30)  50%, transparent 50%)'
    else
      $el.css 'background-image', 'linear-gradient(' + i - 90 + 'deg, transparent 50%, rgb(32, 72, 30) 50%),linear-gradient(90deg, rgb(32, 72, 30)  50%, transparent 50%)'

    if curr < end
      setTimeout (->
        circleAnimate $el, end, ++i
        return
      ), 15

    return







